import React from "react"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import { Sidebar } from "semantic-ui-react"
import DocSidebar from "./sidebar"
import { Link } from "gatsby"
import Logo from "./logo"

import "./layout.scss"

// New
import defStyles from "@modules/style.module.css"


import Search from './Search'

class Layout extends React.Component {
  state = { visible: true, mobile: false }

  render() {
    const { children, title, description } = this.props
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
                sidebar {
                  pages {
                    slug
                    title
                    pages {
                      slug
                      title
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={
                title
                  ? `${title} - ${data.site.siteMetadata.title}`
                  : data.site.siteMetadata.title
              }
              meta={[
                {
                  name: "description",
                  content: description
                    ? description
                    : "Documentation for Nebula Design System",
                },
                {
                  name: "keywords",
                  content: "design system, style guide, documentation",
                },
              ]}
            >
              <html lang="en" />
            </Helmet>
            <Sidebar.Pushable as="section">
            <div className={defStyles.topBar}>
              <div className={defStyles.barNav}>
              <Link
                to="/"
                style={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <Logo siteTitle="Nebula Design System" />
              </Link>
              
                <div className={defStyles.topNav}>
                  <ul>
                  <Link to="/principles" className={defStyles.topNavLi}><li className={defStyles.inlFlx}>Design Principles</li></Link>
                  <Link to="/foundations" className={defStyles.topNavLi}><li className={defStyles.inlFlx}>Design Foundations</li></Link>
                  <Link to="/components" className={defStyles.topNavLi}><li className={defStyles.inlFlx}>Components</li></Link>
                  </ul>
                </div>
                           

                <Search/>

              </div>
            </div>
            {/* <newSideBar items={items} /> */}
            <div className={defStyles.maiCon}>
              <DocSidebar
                sidebarPages={data.site.siteMetadata.sidebar.pages}
                sideBarTitle={data.site.siteMetadata.sidebar.pages.title}
              />  
              <Sidebar.Pusher as="main" className={defStyles.maiDoc}>
                <div className="docs text container">{children}</div>
              </Sidebar.Pusher>
            </div>
            </Sidebar.Pushable>
          </>
        )}
      />
    )
  }
}

export default Layout

